const ServiceNames = {
  TEMPLATE: {
    lecheck: 'リチェックひな型',
    cloudSignReview: 'ひな型'
  },
  STANDARD_TEMPLATE: {
    lecheck: 'リチェックひな型',
    cloudSignReview: '標準ひな型'
  },
  PROVISION: {
    lecheck: 'リチェック条文集',
    cloudSignReview: '参考条文比較'
  }
};

export default ServiceNames;



// WEBPACK FOOTER //
// ./src/constants/common/service_names.js